import { DateTime } from 'luxon';
import { usePledgePotViewCreator } from '@viewCreators/pledge-pot-view-creator';
import { useMemo } from 'react';

export const usePotCard2Controller = (groupId: number, groupStartDate?: DateTime) => {
  const DAY_4 = 4;
  const { data, isLoading, refetch, isFetching, isPending } = usePledgePotViewCreator(groupId);
  const message = 'Keep showing up, and this piece of the program will be revealed before you know it.';

  const enabled = useMemo(() => {
    if (!groupStartDate) {
      return false;
    } else {
      // Pot: day 4
      const daysFromStart = groupStartDate.diffNow('days').days;
      return Math.round(Math.abs(daysFromStart)) >= DAY_4;
    }
  }, [groupStartDate]);

  return {
    potValue: Intl.NumberFormat('en-US', {
      currency: 'USD',
      style: 'currency',
    }).format(data?.potAmount || 0),
    enabled,
    disabledMessage: message,
    isLoading,
  };
};
